import api from 'apis/config/api-service';
import { toCmsListQuery } from 'apis/config/legacy-table-query';

interface OtpParams {
  [key: string]: any;
}

const cmsOtpCodes = 'api/v1/cms/otp-codes';

export default {
  // The list never carries codes; a single OTP (with its code) is fetched on demand.
  getOTPList: (params?: OtpParams) => api.get(cmsOtpCodes, { params: toCmsListQuery(params) }),
  getOTPById: (id: string | number) => api.get(`${cmsOtpCodes}/${id}`),
};
